import { plural } from '@cian/utils';
import { PARKING_LOCATION_LABELS, PARKING_PURPOSE_LABELS, PARKING_TYPE_LABELS } from 'shared/constants/buildingLabels';
import { NBSP } from 'shared/constants/text';
import type { IBuildingParking } from 'shared/types/buildingCard';
import { formatNumber, noBreak } from 'shared/utils/format';

/** `ParkingPresenter.location_display`: расположение и назначение склада, иначе тип парковки */
function getParkingName({ type, locationType, purposeType }: IBuildingParking): string {
  const location = locationType ? PARKING_LOCATION_LABELS[locationType] : undefined;
  const purpose = purposeType ? PARKING_PURPOSE_LABELS[purposeType] : undefined;

  if (location) {
    return purpose ? `${location} ${purpose}` : location;
  }
  if (purpose) {
    return `${purpose.charAt(0).toUpperCase()}${purpose.slice(1)}`;
  }

  return (type && PARKING_TYPE_LABELS[type]) || '';
}

/** Цена в рублях, округлённая вверх (`ParkingPresenter`), затем `render_price`. Без валюты и не в рублях не выводим (см. задачу 4) */
function getPrice(parking: IBuildingParking, key: 'priceHourly' | 'priceMonthly' | 'priceEntry'): string | null {
  const price = parking[key];

  return parking.currency === 'rur' && price ? `от${NBSP}${noBreak(formatNumber(Math.ceil(price)))}${NBSP}₽` : null;
}

function getPriceText(parking: IBuildingParking): string {
  if (parking.isFree) {
    return ', бесплатная';
  }

  const hourly = getPrice(parking, 'priceHourly');
  const monthly = getPrice(parking, 'priceMonthly');
  const entry = getPrice(parking, 'priceEntry');

  if (hourly) {
    return ` ${hourly} в${NBSP}час${NBSP}за${NBSP}место`;
  }
  if (monthly) {
    return ` ${monthly} в${NBSP}месяц${NBSP}за${NBSP}место`;
  }
  if (entry) {
    return ` ${entry} за${NBSP}въезд`;
  }

  return '';
}

/** Строки детальной «Парковки», по одной на парковку, как `detail/index.html` монолита */
export function getParkingLines(parkings: IBuildingParking[]): string[] {
  return parkings.map(parking => {
    const { placesCount } = parking;
    const places = placesCount ? ` на ${placesCount} ${plural(placesCount, ['место', 'места', 'мест'])}` : '';

    return `${getParkingName(parking)}${places}${getPriceText(parking)}`.trim();
  });
}
